import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';
import { inputPlaceholder } from '../../layout/reset';

export const Wrapper = styled.div.withConfig({ componentId: 'sc-16iexqu-0' })`
    --_height: ${size(6)};
    --_gap: ${size(1)};
    --_p-inline: ${size(3)};

    display: flex;
    align-items: center;
    height: var(--_height);
    background-color: var(--c-input-bg);
    border: 1px solid var(--c-input-border);
    border-radius: calc(var(--_height) / 2);

    &:has(:focus-visible) {
        border-color: var(--c-input-border-focus);
    }
`;

export const Icon = styled.div.attrs(() => ({
  'aria-hidden': true,
})).withConfig({ componentId: 'sc-16iexqu-1' })`
    padding-left: var(--_p-inline);
    font-size: ${size(2.5)};
`;

// Scale placeholder text to prevent zoom on iOS focus but follow design
const inputPlaceholderScale = css`
    transform: scale(0.875);
    transform-origin: 0 50%;
`;

export const Input = styled.input.attrs(() => ({
  type: 'search',
})).withConfig({ componentId: 'sc-16iexqu-2' })`
    ${inputPlaceholder};
    flex: 1 1 auto;
    display: block;
    width: 100%;
    height: 100%;
    padding: 0 var(--_p-inline) 0 var(--_gap);
    margin: 0;
    background-color: transparent;
    font-size: var(--font-size-input);
    border: none;
    border-radius: 0;
    box-shadow: none;
    appearance: none;

    &[disabled] {
        cursor: not-allowed;
    }

    &:focus {
        outline: none;
    }

    &::-webkit-input-placeholder {
        ${inputPlaceholderScale}
    }

    &:-moz-placeholder {
        ${inputPlaceholderScale}
    }

    &::-moz-placeholder {
        ${inputPlaceholderScale}
    }

    &:-ms-input-placeholder {
        ${inputPlaceholderScale}
    }
`;
